// extracted by mini-css-extract-plugin
module.exports = {"root":"FormAddress_root__a7v17","rotate":"FormAddress_rotate__5H7AH"};